
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IStop } from "../../../Orchestrator/Types/Index";
import { stopAction } from "../../Index";

export class OpenOriginDestinationDropdownAction extends BaseAction<IStop[], Partial<{ field: string, outsideClick: boolean }>> {

    override async run(): Promise<IStop[]> {
        let data: IStop[] = []
        try {
            if (stopAction.result == null) {
                await stopAction.execute();
                // data = stopAction?.result || []
            } else {
                // data = stopAction?.result || []
            }
            const { field, outsideClick } = this.params!;
            if (outsideClick) {
                updateRecoilState("isSelectingOriginAtom", false);
                updateRecoilState("isSelectingDestinationAtom", false);
                updateRecoilState("subStationDropdownAtom", {})
            }
            else {
                if (field === "origin") {
                    updateRecoilState("isSelectingOriginAtom", true);
                    updateRecoilState("isSelectingDestinationAtom", false);
                }
                else if (field === "destination") {
                    updateRecoilState("isSelectingDestinationAtom", true);
                    updateRecoilState("isSelectingOriginAtom", false);
                }
            }

        } catch (error) {
            console.error("Error in OpenOriginDestinationDropdownAction:", error);
        }
        finally {
            return data
        }
    }
}

// Create a singleton instance
export const openOriginDestinationDropdownAction = new OpenOriginDestinationDropdownAction(); 